import { render } from "./MonthlyTrainingListReport.vue?vue&type=template&id=1f6a2c9a&scoped=true"
import script from "./MonthlyTrainingListReport.vue?vue&type=script&lang=js"
export * from "./MonthlyTrainingListReport.vue?vue&type=script&lang=js"

import "./MonthlyTrainingListReport.vue?vue&type=style&index=0&id=1f6a2c9a&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a2c9a"]])

export default __exports__